export const validationMessage = {
    genderValidation: "Please select gender",
    titleValidation: "Please select title",
    firstNameValidation: "Please enter first name",
    surnameValidation: "Please enter surname",
    emailValidation: "Please enter email address",
    dateOfBirthValidation: "Please select date of birth",
    dateOfBirthCurrentDateValidation: "Please select date before current date",
    dateOfBirthJuniorValidation:
        "DOB indicates this is a junior. Client age must be 18 or older, please select a valid date or choose 'Child' Client type",
    dateOfBirthIndividualValidation:
        "DOB indicates this is not a junior. Client age must be under 18, please select a valid date or choose 'Individual' Client type",
    adviserValidation: "Please select adviser",
    clientTypeValidation: "Please select client type",
    firmValidation: "Please select firm",
    networkValidation: "Please select network",
    landlienNumberValidation: "Invalid landline phone number entered",
    GuardianValidation: "Please select Guardian",
    dateOfBirthGuardianValidation:
        "DOB indicates this is a junior. Guardian age must be more than 18, please select a valid date or choose 'Individual' Client type",
};
